import { gql } from '@apollo/client';

export default gql`
  query {
    getAllStatus {
      title
      id
      is_default
    }
  }
`;
